import defaultTheme from './defaultTheme';
import defaultDarkTheme from './defaultDarkTheme';
import { ReactNode, useMemo } from 'react';
import { ThemeProvider, CssBaseline, useColorScheme } from '@mui/material';

// theme/mergeTheme.ts
import { ThemeOptions, createTheme } from '@mui/material/styles';
import { useAppSelector } from '../redux/store';

export function mergeTheme(baseTheme: ThemeOptions, incoming?: ThemeOptions) {
	if (!incoming) return createTheme(baseTheme);

	return createTheme(baseTheme, incoming);
}

export const AppTheme = ({ children }: { children: ReactNode }) => {
	const { mode } = useColorScheme();

	const remoteTheme = useAppSelector(s => s.brand.data?.theme);
	const theme = useMemo(() => {
		if (mode === 'dark') {
			return mergeTheme(defaultDarkTheme, remoteTheme?.dark);
		}
		if (mode === 'light') {
			return mergeTheme(defaultTheme, remoteTheme?.light);
		}
		return mergeTheme(defaultTheme, remoteTheme?.light);
	}, [mode, remoteTheme]);

	return (
		<ThemeProvider theme={theme} defaultMode="system">
			<CssBaseline />
			{children}
		</ThemeProvider>
	);
};
